<footer>
    <div class="footer-div" fxFlex=100 fxLayout="row wrap">
        <div class="logo-div" fxFlex=22 fxLayout="row" fxLayoutAlign="start center">
            <span class="cinejoy-logo">cinejoy</span>
            <span class="creatics-logo">|CREATICS</span>
        </div>



        <div class="details-div" fxLayout="column wrap" fxFlex=70 fxLayoutGap="20px grid" fxLayoutAlign="end center">
            <div class="margin-div" fxLayout="column">
                <div class="icons" fxLayout="row wrap" fxLayoutGap="30px">
                    <a href="https://www.instagram.com/creaticsorg"><i class="fa fa-instagram fa-3x"
                            aria-hidden="true"></i></a>
                    <a href="https://www.facebook.com/CreaticsEnterprises"><i class="fa fa-facebook fa-3x"
                            aria-hidden="true"></i></a>
                    <a href="https://twitter.com/Creatics2"><i class="fa fa-twitter fa-3x" aria-hidden="true"></i></a>
                </div>
                <div class="creatics-details" fxLayout="column">
                    <p class="creatics-title">
                        {{header?.description}}
                    </p>
                    <p class="creatics-contact" fxLayoutGap="10px">
                        <ng-container *ngFor="let item of footerList; first as isFirst; last as isLast">
                            <a [href]="item.link">{{item.section}} </a> <ng-container>/
                                &nbsp; </ng-container>
                        </ng-container>
                        <ng-container>
                            <ng-container *ngIf="footerList?.length <= 0">/
                                &nbsp; </ng-container> <a href="mailto:cinejoycustomers@cinequest.org">Contact Us</a>
                        </ng-container>
                    </p>
                    <p class="creatics-footer">
                        © {{copyright}}
                    </p>
                </div>
                    <div class="store-buttons">
                        <!-- Google Play Store Button -->
                        <a href="https://play.google.com/store/apps/details?id=com.creatics.mobile.live" target="_blank">
                            <img src="../../../../../assets/images/playstore.png" alt="Get it on Google Play" class="store-badge">
                        </a>
                
                        <!-- Apple App Store Button -->
                        <a href="https://apps.apple.com/app/id1613121215" target="_blank">
                            <img src="../../../../../assets/images/app_store.svg" alt="Download on the App Store" class="store-badge">
                        </a>
                    </div>

            </div>
        </div>
    </div>

</footer>